import React from 'react';

interface Props {
  name: string;
  className?: string;
  title?: string;
}

/**
 * Material Symbols icon, matching the sidebar/nav icon style
 * (`material-symbols-outlined`, loaded in index.html).
 */
const MaterialIcon: React.FC<Props> = ({ name, className = '', title }) => (
  <span
    className={`material-symbols-outlined ${className}`}
    aria-hidden={title ? undefined : true}
    title={title}
    translate="no"
  >
    {name}
  </span>
);

export default MaterialIcon;
